<template>
  <div>
    <div class="form-group radio-group form-check form-check-inline" :id="handle">
      <label v-for="o in options" :for="'kriterium_'+criteriaId+'_'+o.code"  :class="labelClass">
        <input :id="'kriterium_'+criteriaId+'_'+o.code" type="radio" :class="inputClass" :value="o" v-model="selectedValue" autocomplete="off" v-on:change="change">{{ getBezeichung(o) }}
      </label>
    </div>
  </div>
</template>
<style></style>
<script>
export default {
  name: "filter-criteria-radio",
  props: {
    label: String,
    handle: String,
    criteriaId: Number,
    inputClass: String,
    labelClass: String,
    placeholder: String,
    value: [Object, Boolean, Array],
    optionsEndpoint: [ String, Boolean ],
    optionsInit: Array
  },
  computed: {
    completeOptionsEndpoint: function () {
      if(this.optionsEndpoint){
        return this.optionsEndpoint.replace('{code}', this.criteriaId);
      }
      return null;
    }
  },
  data: function () {
    return {
      selectedValue: this.value,
      options: []
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    getBezeichung: function( optionsObj ) {
      if(optionsObj.bezeichnung) return optionsObj.bezeichnung;
      if(optionsObj.label) return optionsObj.label;
      return '';
    },
    getOptions: function () {
      axios.get(this.completeOptionsEndpoint)
          .then(response => (this.options = response.data));
    },
    change() {
      var self = this;
      var opt = this.options.find(function(o){
        return o.code === self.selectedValue || o.code === self.selectedValue.code
      });
      if(opt){
        this.selectedValue = opt;
      }
      this.$emit('input', this.selectedValue);
    }
  },
  destroyed: function () {

  },
  created() {
    if(this.optionsEndpoint){
      this.getOptions();
    } else {
      this.options = this.optionsInit;
    };
    /*if(this.selectedValue === null || this.selectedValue === undefined || this.selectedValue === 0){
      this.selectedValue = {
        code: 0,
        bezeichnung: this.placeholder
      }
    }*/
  },
  mounted() {

  }
}
</script>
